export default function MotifsConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('motifs');
}

MotifsConfiguration.$inject = ['$translatePartialLoaderProvider'];
